import {Text} from "finhelper";

/**
 * Структура объекта контакта либо клиента, идущего в эвент дашборда либо календаря
 */
export interface TaskContactDTO {
    id: string; // айдишник здесь преобразован и ВСЕГДА будет с припиской '-user' или '-contact'
    clearId: number;
    innerType: 'user' | 'contact';
    last_name: string;
    first_name: string;
    name: string;
    avatar?: string;
}

export const mapToTaskContactDTO = (
    items: Array<{ id: number; last_name?: string; first_name?: string; email?: string; avatar?: string }>,
    type: 'user' | 'contact'
): TaskContactDTO[] => {
    return items.map((item) => ({
        id: `${item.id}-${type}`,
        clearId: item.id,
        innerType: type,
        last_name: item.last_name ?? '',
        first_name: item.first_name ?? '',
        name: Text.fio(item) + (item.email ? ` (${item.email})` : ''),
        avatar: item.avatar,
    }));
};